import React, {useState} from 'react'
import SuspenseLoading from '@components/SuspenseLoading'
import {useUserPreferences} from '@data/queries/preferences/userPreferences.main'
import useEffect from '@hooks/useEffect'
import useShouldHidePrice from '@hooks/useShouldHidePrice'
import useWebsiteId from '@hooks/useWebsiteId'
import useWidth from '@hooks/useWidth'
import {useApolloQuery} from 'apollo-hooks'
import Link from 'next/link'

import Loading from '../../Products/ProductsContent/Loading'

import GoBack from './TopRow/GoBack'
import Breadcrumbs from './Breadcrumbs'
import getCategoryQuery from './getCategoryQuery'
import ProductFilters from './ProductFilters'
import ProductFiltersContextProvider from './ProductFiltersContextProvider'
import Products from './Products'
import TopRow from './TopRow'

import styles from './styles.module.css'

export default function CategoryContent({categoryId, filter}) {
  const websiteId = useWebsiteId()
  const data = useUserPreferences()
  const {menuId} = data
  const shouldHidePrice = useShouldHidePrice()
  const {category} = useApolloQuery({query: getCategoryQuery, variables: {categoryId}})

  const [order, setOrder] = useState(null)

  const width = useWidth()
  const isMobile = width <= 768

  useEffect(() => {
    if (!category || !category.sorting) {
      setOrder(null)
      return () => {}
    }

    const expectedOrder = Object.keys(category.sorting)
      .filter(key => key !== '__typename' && category.sorting[key])
      .reduce((acc, value) => {
        acc[value] = category.sorting[value]
        return acc
      }, {})

    setOrder(Object.keys(expectedOrder).length > 0 ? expectedOrder : null)
  }, [category?._id])

  if (!category) {
    return <Loading />
  }

  return (
    <ProductFiltersContextProvider
      categoryId={categoryId}
      menuId={menuId}
      category={category}
      websiteId={websiteId}>
      <div className={styles.container}>
        {/* TOP ROW */}
        <Breadcrumbs category={category} />
        <TopRow category={category} order={order} setOrder={setOrder} />
        <br />
        {/* CONTENT */}
        <div className={styles.inner}>
          {/* LEFT START */}
          <div className={styles.left}>
            {category.subCategories.items.length > 0 ? (
              <>
                <div className={styles.leftBlockTop} />
                <div className={styles.leftBlockTitle}>
                  <h3>{category.name}</h3>
                </div>
                <div className={styles.leftBlockSpacer} />
                <div className={styles.leftBlockCategories}>
                  {category.subCategories.items.map((subcat, idx) => (
                    <Link
                      href={`/pedir/category/${subcat._id}`}
                      key={idx}
                      prefetch={false}
                      scroll={false}
                      className={styles.subCatLink}>
                      {subcat.name}
                    </Link>
                  ))}
                </div>
              </>
            ) : (
              <GoBack category={category} />
            )}
          </div>
          {/* FILTER START */}
          <div>
            <SuspenseLoading>
              <div className={styles.filters}>
                {!isMobile && <ProductFilters setOpenFilters={false} />}
              </div>
            </SuspenseLoading>
          </div>
          {/* RIGHT START */}
          <div className={styles.right}>
            <SuspenseLoading>
              <Products
                categoryId={categoryId}
                categoryName={category.name}
                filter={filter}
                parent={category.parent}
                order={order}
                shouldHidePrice={shouldHidePrice}
              />
            </SuspenseLoading>
          </div>
        </div>
      </div>
    </ProductFiltersContextProvider>
  )
}
